import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { LeaderboardTable } from '../components/LeaderboardTable';
import { useLeaderboard } from '../hooks/useLeaderboard';
import { HomeIcon, DumbbellIcon, BrainCircuitIcon } from 'lucide-react';
interface LeaderboardsProps {
  onHome: () => void;
}
export function Leaderboards({
  onHome
}: LeaderboardsProps) {
  const {
    entries
  } = useLeaderboard();
  const [activeTab, setActiveTab] = useState<'brawn' | 'brains'>('brawn');
  // Brawn: sort descending (higher = better)
  const brawnScores = entries.filter(e => e.type === 'brawn').sort((a, b) => b.score - a.score).slice(0, 10);
  // Brains: sort ascending (lower time = better)
  const brainScores = entries.filter(e => e.type === 'brains').sort((a, b) => a.score - b.score).slice(0, 10);
  return <div className="min-h-screen bg-zinc-950 p-4 md:p-8" data-id="element-461">
      <div className="max-w-4xl mx-auto" data-id="element-462">
        <div className="flex justify-between items-center mb-8" data-id="element-463">
          <Button onClick={onHome} variant="outline" size="sm" className="flex items-center gap-2" data-id="element-464">
            <HomeIcon className="w-4 h-4" data-id="element-465" /> BACK
          </Button>
          <h1 className="text-2xl md:text-4xl font-bold text-white uppercase tracking-wider" data-id="element-466">
            HALL OF FAME
          </h1>
          <div className="w-24" data-id="element-467" />
        </div>

        <div className="flex mb-8 bg-zinc-900 p-1 rounded-lg border border-zinc-800" data-id="element-468">
          <button onClick={() => setActiveTab('brawn')} className={`flex-1 py-4 flex items-center justify-center gap-2 rounded transition-all duration-300 ${activeTab === 'brawn' ? 'bg-orange-600 text-white shadow-lg' : 'text-gray-400 hover:text-white'}`} data-id="element-469">
            <DumbbellIcon className="w-5 h-5" data-id="element-470" />
            <span className="font-bold uppercase italic text-lg" data-id="element-471">
              BRUTES BOARD
            </span>
          </button>
          <button onClick={() => setActiveTab('brains')} className={`flex-1 py-4 flex items-center justify-center gap-2 rounded transition-all duration-300 ${activeTab === 'brains' ? 'bg-cyan-600 text-white shadow-lg' : 'text-gray-400 hover:text-white'}`} data-id="element-472">
            <BrainCircuitIcon className="w-5 h-5" data-id="element-473" />
            <span className="font-mono font-bold text-lg" data-id="element-474">NERDS BOARD</span>
          </button>
        </div>

        <div data-id="element-475">
          {activeTab === 'brawn' ? <div data-id="element-476">
              <div className="mb-4 text-orange-500 text-sm font-bold uppercase tracking-wider text-center" data-id="element-477">
                Top Grip Strength Records — Higher is Better
              </div>
              <LeaderboardTable entries={brawnScores} type="brawn" data-id="element-478" />
            </div> : <div data-id="element-479">
              <div className="mb-4 text-cyan-500 text-sm font-mono text-center" data-id="element-480">
                Fastest Keep-or-Toss Times — Lower is Better
              </div>
              <LeaderboardTable entries={brainScores} type="brains" data-id="element-481" />
            </div>}
        </div>
      </div>
    </div>;
}